<template>
    <div class="apprentice-simple-card">
        <b-button
            class="btn-add btn-add-calendar-item"
            v-if="!this.$authUser.isStudent()"
            variant="primary"
            @click="showAddCalendarItemModal">
            Nieuwe afspraak
        </b-button>

        <design-2021-apprentice-fullcalendar-component
            ref="portfolioCalendar"
            :types="['listYear', 'dayGridWeek', 'dayGridMonth']"
            :calendar-items-in="calendarItems"
            :right-buttons="true"
            :emit-changed-date="true"
            @update-item="settingsAgendaItem($event)"
            @change-date="changeDate($event)">
        </design-2021-apprentice-fullcalendar-component>

        <design-2021-portfolio-show-calendar-settings-modal-component
            :ref="'portfolio-calender-item-settings-modal'"
            @update-item="showEditCalendarItemModal"
            @delete-item="deleteCalendarItem"
            :item-in="selectedItem">
        </design-2021-portfolio-show-calendar-settings-modal-component>

        <design-2021-portfolio-show-calendar-add-item-modal-component
            :project-id="projectId"
            @updateAgendaItems="calendarItemsUpdate"
            :project-type="projectType">
        </design-2021-portfolio-show-calendar-add-item-modal-component>

        <design-2021-portfolio-show-calendar-edit-item-modal-component
            :project-id="projectId"
            :calendar-in="selectedItem"
            @editAgendaItems="calendarItemsEdit"
            :project-type="projectType">
        </design-2021-portfolio-show-calendar-edit-item-modal-component>
    </div>
</template>

<script>
export default {
    name: 'design-2021-portfolio-show-calendar-component',
    props: ['agendaItems', 'projectId', 'projectType'],
    data() {
        return {
            calendarItems: this.agendaItems.map((item) => {
                let color = '';

                switch (item.type_id) {
                    // 1 = logboek
                    case 1:
                        color = 'blue';
                        break;
                    // 2 = planning
                    case 2:
                        color = 'orange';
                        break;
                    // 3 = deadline
                    case 3:
                        color = 'red';
                        break;
                    default:
                        color = 'orange';
                }

                let start;
                let end = null;

                if (item.time) {
                    start = item.date_time;
                } else {
                    start = item.date;
                }
                if (item.date_time_end_date) {
                    end = item.date_time_end_date;
                } else {
                    end = start;
                }

                let hasRoadmap = false;

                if (item.model_type === 'App\\Models\\Roadmap\\RoadmapStep') {
                    hasRoadmap = true;
                }

                let isDeadline = false;

                if (
                    item.model_type === 'App\\Models\\Assignment\\AssignmentDeadline' ||
                    item.model_type === 'App\\Models\\Assignment\\SubAssignmentDeadline'
                ) {
                    isDeadline = true;
                }

                return {
                    id: item.id,
                    title: item.title,
                    date: item.date,
                    created_by: item.created_by,
                    date_end: item.date_end,
                    date_time: item.date_time,
                    date_time_end_date: item.date_time_end_date,
                    description: item.description,
                    location: item.location,
                    time: item.time,
                    time_end: item.time_end,
                    color: color,
                    roadmap: hasRoadmap,
                    start: start,
                    end: end,
                    isDeadline,
                    assignment_id: item.assignment_id,
                    project_id: item.project_id,
                    model_type: item.model_type,
                };
            }),
            selectedItem: {},
            localStorageName: `portfolio-calendar-view-${this.projectId}${this.$authUser.id}`,
            init: true,
        };
    },
    methods: {
        settingsAgendaItem(item) {
            this.calendarItems.forEach((calendarItem) => {
                if (calendarItem.id === Number(item.id)) {
                    this.selectedItem = calendarItem;
                }
            });

            this.$refs['portfolio-calender-item-settings-modal'].show();
        },

        deleteCalendarItem() {
            this.alert
                .confirm('Afspraak verwijderen', 'Weet je zeker dat je deze afspraak wil verwijderen?')
                .then((confirm) => {
                    if (confirm) {
                        this.alert.saving();

                        this.axios.delete(this.routes.paperCalendarDelete(this.projectId, this.selectedItem.id)).then(
                            (response) => {
                                this.alert.success();

                                this.calendarItems = this.calendarItems.filter(
                                    (calendarItem) => calendarItem.id !== this.selectedItem.id,
                                );
                            },
                            (error) => {
                                this.alert.ajaxError(error);
                            },
                        );
                    }
                });
        },

        showAddCalendarItemModal() {
            this.$bvModal.show('portfolio-create-calendar-item-modal');
        },
        showEditCalendarItemModal() {
            this.$bvModal.show(`portfolio-edit-calendar-item-${this.selectedItem.id}`);
        },
        calendarItemsUpdate(values) {
            let color = '';

            switch (values.agenda_item.type_id) {
                // 1 = logboek
                case 1:
                    color = 'blue';
                    break;
                // 2 = planning
                case 2:
                    color = 'orange';
                    break;
                // 3 = deadline
                case 3:
                    color = 'red';
                    break;
                default:
                    color = 'orange';
            }

            values.agenda_item.color = color;

            this.calendarItems.push(values.agenda_item);
        },
        calendarItemsEdit(values) {
            this.calendarItems = this.calendarItems.map((item) => {
                if (values.agenda_item.id === item.id) {
                    item.date = values.agenda_item.date;
                    item.date_end = values.agenda_item.date_end;
                    item.description = values.agenda_item.description;
                    item.title = values.agenda_item.title;
                    item.time = values.agenda_item.time;
                    item.time_end = values.agenda_item.time_end;
                }
                return item;
            });
        },

        changeDate(data) {
            if (this.init) {
                if (localStorage.getItem(this.localStorageName) && this.init) {
                    this.$refs.portfolioCalendar.$refs.fullCalendar.calendar.changeView(
                        localStorage.getItem(this.localStorageName),
                    );
                    this.init = false;
                }
            }

            localStorage.setItem(this.localStorageName, data.view);
        },
    },

    mounted() {
        this.$nextTick(() => {
            if (
                localStorage.getItem(this.localStorageName) &&
                this.localStorageName === `group-calendar-view-${this.groupId}${this.$authUser.id}`
            ) {
                this.$refs.portfolioCalendar.$refs.fullCalendar.calendar.changeView(
                    localStorage.getItem(this.localStorageName),
                );
            }
        });
    },
};
</script>

<style scoped lang="scss">
.paper-tools-calendar {
    > .row {
        height: inherit;
    }
}

.new-appointment {
    display: flex;
    justify-content: flex-end;
}

.new-appointment,
.month-view {
    margin-bottom: map-get($grid-gutter-spacing, 'twenty-one');
}

.monthly-items {
    height: 100%;
    min-height: 300px;
}

.appointment-item {
    position: relative;

    .appointment-item-management {
        display: flex;
        align-items: center;
        justify-content: flex-end;
        position: absolute;
        top: 0;
        right: 0;
        opacity: 0;
        transition: opacity 0.3s ease-in-out;

        .btn {
            &:before {
                margin-right: 0;
            }

            &:not(:last-child) {
                margin-right: map-get($grid-gutter-spacing, 'fifteen');
            }
        }
    }

    &:hover {
        cursor: pointer;

        .appointment-item-management {
            opacity: 1;
        }
    }

    &:not(:first-child) {
        .appointment-item-management {
            top: map-get($grid-gutter-spacing, 'fifteen');
        }
    }
}

.calendar-month-view {
    text-align: center;
}

@media (min-width: map-get($grid-breakpoints, 'md')) {
    .calendar-month-view {
        text-align: center;
    }
}

@media (min-width: map-get($grid-breakpoints, 'xl')) {
    .month-view {
        margin-bottom: 0;
    }
}
</style>
